/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

export default reEscape;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/_reEscape.js
// module id = null
// module chunks = 